
    export default {
        props: {
            fixed: { default: false, type: Boolean },
            optional: { default: false, type: Boolean },
            displayName: { required: true, type: String },
            value: { required: true },
        },
        data () {
            return {
                isVisible: !this.optional,
                name: this.label,
            };
        },
        methods: {
            applyFilter() {
                this.$emit('apply-filter');
            },
        },
        watch: {
            isVisible(newValue) {
                this.$emit('visibility-changed', newValue);
            },
            value: {
                handler(newValue) {
                    this.$emit('value-changed', newValue);
                },
                deep: true,
            },
        },
    };
